<div class="faq-card">
  <div class="row">
    <div class="col-md-12">
      <h2 class="mb-0 text-center f-bold">Frequently Asked Questions</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="accordion mt-3" id="accordionExample1">
        <div class="card">
          <div class="card-header" id="headingOne">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                Which CAT course is best for non-engineers to prepare for CAT 2025?
              </button>
            </h2>
          </div>
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample1">
            <div class="card-body">
              <p class="f-light">You can go for iQuanta flagship course <a href="https://www.iquanta.in/cat-2025"> CAT
                2025</a> Full Course or the CAT 2025 Pro Batch. These courses provide conceptual videos for
              non-engineers, for those who are extremely weak in quant, and After completion of each topic, there is a
              marathon that carries questions of CAT 2023. We provide a topic-wise <a
                href="https://www.iquanta.in/cat-mock-test">CAT mock test</a>, 50 Questions on each Topic as <a
                href="https://www.iquanta.in/test/free-cat-study-material">Study Material</a> and 10 + Sets of
              Hardcopy CAT Material as per the Updated Pattern (5000 Questions). The Course has 250+ Recorded Videos
              and practice sessions after each class along with 24x7 instant doubt support.</p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingTwo">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                Is it necessary to opt for any CAT coaching?
              </button>
            </h2>
          </div>
          <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample1">
            <div class="card-body">
              <p class="f-light">It depends on individual hard work and practice but having a mentor beside you can help you crack the exam easily. iQuanta is the best when it comes to content, study material or doubt resolution.</p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingThree">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                When should I join a CAT course?
              </button>
            </h2>
          </div>
          <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample1">
            <div class="card-body">
              <p class="f-light">Generally, there is no right time to join any CAT course. You can go for it while in college or after graduation depending on when you want to do your MBA.</p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingFour">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                Should I self-prepare or go with a CAT coaching?
              </button>
            </h2>
          </div>
          <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample1">
            <div class="card-body">
              <p class="f-light">You can go with either depending on how familiar you are with aptitude tests. But the best combination would be CAT coaching along with self-study. Coaching will simplify your hunt for study material and structure your preparation. iQuanta’s CAT Course also ensures that all your doubts and instantly resolved. Meanwhile, self-practicing will help you in getting familiar with all types of questions.</p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingFive">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFour">
                Is CAT online coaching a good idea?
              </button>
            </h2>
          </div>
          <div id="collapseFive" class="collapse" aria-labelledby="headingFive" data-parent="#accordionExample1">
            <div class="card-body">
              <p class="f-light">CAT online coaching is pocket-friendly and easily accessible according to student convenience. It saves time as well as energy for students.  iQuanta provides several online CAT courses which makes learning easy. You can go for the iQuanta CAT 2025 full course which involves conceptual videos for non-engineering students, topic-wise tests, assignments, full CAT mocks and a Crash Course in addition to a Live & application class with 24x7 doubt assistance.</p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingSix">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseSix" aria-expanded="false" aria-controls="collapseFour">
                Which CAT online coaching is helpful if I am weak in Quants?
              </button>
            </h2>
          </div>
          <div id="collapseSix" class="collapse" aria-labelledby="headingSix" data-parent="#accordionExample1">
            <div class="card-body">
              <p class="f-light">iQuanta’s CAT course is the right choice as it has a customised module for those who are extremely weak in Mathematics. This module is in alignment with the NCERT class 6-10 syllabus. So if you have lost touch with Mathematics or have not studied Maths after class 12 then this module is definitely for you. The Quant section has basic Maths that we have studied in class 6 to 10 such as number system, average, ratio & proportion, profit & loss, probability, geometry, time, work & distance, etc. So you will be taught all the topics from the basic concepts itself. So the iQuanta CAT course is really helpful for you if you are struggling with Mathematics.</p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingSeven">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="false" aria-controls="collapseFour">
                Will I get the complete guidance and mentorship if I join a CAT online course?
              </button>
            </h2>
          </div>
          <div id="collapseSeven" class="collapse" aria-labelledby="headingSeven" data-parent="#accordionExample1">
            <div class="card-body">
              <p class="f-light">Yes, iQuanta expert team will provide you with personalised mentorship throughout your CAT journey. Every aspirant has their own strengths and weaknesses and have their own journey and therefore need a personalised strategy to crack the exam. At iQuanta you will get the complete guidance and mentorship from the top faculties and they will help you while making your strategies and plans for CAT.</p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingEight">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseEight" aria-expanded="false" aria-controls="collapseFour">
                How fast will my doubts get solved if I join a CAT coaching?
              </button>
            </h2>
          </div>
          <div id="collapseEight" class="collapse" aria-labelledby="headingEight" data-parent="#accordionExample1">
            <div class="card-body">
              <p class="f-light">24*7 doubt solving facility is the most unique feature of iQuanta CAT course. So any time you have a doubt it gets resolved instantly within 15 minutes. This will pace up your preparation and don’t have to waste your time waiting for your doubts to get resolved. This facility is only provided by the best CAT online coaching - iQuanta.
              </p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingNine">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseNine" aria-expanded="false" aria-controls="collapseFour">
                Will iQuanta’s CAT course help me while preparing with my job?
              </button>
            </h2>
          </div>
          <div id="collapseNine" class="collapse" aria-labelledby="headingNine" data-parent="#accordionExample1">
            <div class="card-body">
              <p class="f-light">Yes, iQuanta’s CAT course is suitable for working professionals. The timings of the classes are scheduled at night so that you can attend the classes when you are free from your job. You also get back up of the classes so that you can easily access them if you have missed it. It also has special batches on weekends that are specially designed for working professionals.
              </p>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingTen">
            <h2 class="mb-0">
              <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTen" aria-expanded="false" aria-controls="collapseFour">
                Does iQuanta’s CAT course have relevant content?
              </button>
            </h2>
          </div>
          <div id="collapseTen" class="collapse" aria-labelledby="headingTen" data-parent="#accordionExample1">
            <div class="card-body">
              <p class="f-light">Yes, iQuanta CAT course has relevant content and students themselves have shared the feedback that they have witnessed the same questions in the CAT exam that was taught in the classes. This is also one of the reason why iQuanta has got 500+ 99 percentilers in CAT 2024
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>